import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { Button } from './Button';
import { everythingIncluded, noMore } from '../data/includes';
import { CHECKOUT_URL, trackInitiateCheckout } from '../utils/tracking';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-terracotta-deep text-paper" data-id="element-101" data-mp="85fc0zc93r28">
      <div className="max-w-4xl mx-auto" data-id="element-102" data-mp="87a20s2dq9d6">
        <div className="text-center mb-16" data-id="element-103" data-mp="m4f5qlemew59">
          <p className="text-paper/70 font-semibold tracking-[0.18em] uppercase text-xs mb-3" data-id="element-104" data-mp="m340si9fvick">
            Your Next Teaching Week
          </p>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight" data-id="element-105" data-mp="vv9pnj4e9jnj">
            You can spend the next few days building your art classes from
            scratch...
            <br data-id="element-106" data-mp="2h5u5x00jv4id" />
            <span className="text-[#F2C9A8]" data-id="element-107" data-mp="2m2ubzaxeg79h">
              Or you can walk into the classroom with everything prepared,
              organized, and ready to teach.
            </span>
          </motion.h2>

          <ul className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-white/10 p-8 rounded-2xl border border-paper/20" data-id="element-108" data-mp="2v3sf7r00kar0">
            {noMore.map(item => <li key={item} className="flex items-start gap-3" data-id="element-109" data-mp="300sosbw2nvmv">
                <span className="text-[#F2C9A8] mt-1" aria-hidden="true" data-id="element-110" data-mp="34udb36oaz168">
                  ✦
                </span>
                <span className="text-paper/90" data-id="element-111" data-mp="39rvnj71j3yiz">{item}</span>
              </li>)}
          </ul>

          <p className="text-xl mb-2" data-id="element-112" data-mp="3et2syzg78lmh">
            Art Teacher Ready doesn't make you a better teacher.
          </p>
          <p className="text-2xl font-bold text-[#F2C9A8] mb-6" data-id="element-113" data-mp="3ir0i629yz7pv">
            You're already the teacher.
          </p>
          <p className="text-xl text-paper/90" data-id="element-114" data-mp="1ep8mvhraws3k">
            What Art Teacher Ready does is give you the time and tools to make
            your teaching visible in every class.
          </p>
        </div>

        <div className="bg-paper text-charcoal rounded-3xl p-8 md:p-12" data-id="element-115" data-mp="1nq6usb4v1jrf">
          <h3 className="text-2xl font-bold mb-6 text-center border-b border-warmgray pb-6" data-id="element-116" data-mp="1nnu85ko5ql81">
            Everything Included
          </h3>

          <ul className="grid md:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-id="element-117" data-mp="1xgjdryx114vg">
            {everythingIncluded.map(item => <li key={item} className="flex items-start gap-3" data-id="element-118" data-mp="2be807b6qsk2m">
                <Check size={18} className="text-terracotta shrink-0 mt-0.5" aria-hidden="true" data-id="element-119" data-mp="27e7cezxr6wiw" />
                <span className="text-sm text-charcoal-soft" data-id="element-120" data-mp="h3kvxcdm71zf">{item}</span>
              </li>)}
          </ul>

          <div className="text-center" data-id="element-121" data-mp="2w82j6pgceyj">
            <div className="mb-8 p-6 bg-sand rounded-xl border border-warmgray italic text-charcoal-soft text-lg" data-id="element-122" data-mp="2x9f5fm499id">
              “The best time to have this teaching library was before your first
              art class.
              <br data-id="element-123" data-mp="3pbaobq6gb04s" />
              <span className="text-terracotta-deep font-bold not-italic" data-id="element-124" data-mp="3p9q2coy7cpij">
                The second best time is today.
              </span>
              ”
            </div>

            <p className="text-xl font-serif font-bold mb-2" data-id="element-125" data-mp="3fc1y98epi5np">
              Art Teacher Ready
            </p>
            <p className="text-sm text-charcoal-muted mb-8" data-id="element-126" data-mp="3kad7pi13ae5e">
              7 complete volumes of art lessons ready to teach, created to help
              art teachers plan less, teach with confidence, and keep every
              class creative, visual, varied, and professionally structured.
            </p>

            <Button href={CHECKOUT_URL} target="_blank" onLinkClick={trackInitiateCheckout} className="w-full md:w-auto text-lg md:text-xl py-5 px-10 mb-6 bg-burnt-light hover:bg-terracotta-dark" data-id="element-127" data-mp="14jh9v7evt1hm">
              GET THE COMPLETE TEACHING LIBRARY NOW
            </Button>

            <div className="flex flex-wrap justify-center gap-4 text-xs text-charcoal-muted" data-id="element-128" data-mp="2volqnkijlw4c">
              <span data-id="element-129" data-mp="2rojola8wb0oj">7-day money-back guarantee</span>
              <span data-id="element-130" data-mp="2rpuwnm9diulg">·</span>
              <span data-id="element-131" data-mp="2mofafqvgmi1h">Instant access</span>
              <span data-id="element-132" data-mp="2mpgtahipw8tr">·</span>
              <span data-id="element-133" data-mp="2mqrwaf4c9cjt">Pay once, use forever</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}